import { styled } from "@mui/material/styles";

/**
 * MenuHeaderWrapper is the support component used to correctly render
 * GreenRouter UI menu so that it appears below the application top bar.
 */
const MenuHeaderWrapper = styled("div")(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	padding: theme.spacing(0, 2),
	...theme.mixins.toolbar, // Required so that content is rendered below the app bar.
}));

export default MenuHeaderWrapper;
